import * as React from 'react';
import { IConfigPrice } from 'components/Catalog/Product/Detail';

interface IProps {
    price: IConfigPrice;
    eStorePriceLabel: string;
    storePriceLabel: string;
    oldPrice?: string;
    isSpecialPriceDiscount?: boolean;
}

const Price = (props: IProps) => {
    const { price, oldPrice, isSpecialPriceDiscount, eStorePriceLabel, storePriceLabel } = props;

    return (
        <React.Fragment>
            {oldPrice && (
                <React.Fragment>
                    <li className="primary">
                        <div className="label">{eStorePriceLabel}</div>
                        <div className={`price sale`}>{price.valueLabel}</div>
                    </li>
                    <li>
                        <div className="label">{storePriceLabel}</div>
                        <div className="price">{oldPrice}</div>
                    </li>
                </React.Fragment>
            )}
            {!oldPrice && <div className="price">{price.valueLabel}</div>}
        </React.Fragment>
    );
};

export default Price;
